import { InjectionToken } from '@angular/core';

export interface RewardsContentConfig {
  /** CloudFront base URL serving the cached content JSON under /csconfig/* */
  baseUrl: string;
}

export const REWARDS_CONTENT_CONFIG = new InjectionToken<RewardsContentConfig>('REWARDS_CONTENT_CONFIG');